import { ActionTypes } from '../../constants/ActionTypes';
import { IDeleteDraftReducer } from '../../interfaces';
const INIT_STATE: IDeleteDraftReducer = {
  response: false,
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.DELETE_DRAFT: {
      return {
        ...state,
      };
    }
    case ActionTypes.DELETE_DRAFT_SUCCESS: {
      return {
        ...state,
        response: action.payload,
      };
    }

    default:
      return state;
  }
};
